<template>
  <div>
    <!--  固定位搜索栏  -->
    <div class="fixed width-99 z-99 bg-FF p-20" style="border-top: 1px solid #ccc">
      <van-row class="text-center" type="flex" justify="space-between" align="center">
        <van-col class="font-32 cor-cc">
          <van-button @click="lastWeek">上一周</van-button>
        </van-col>
        <van-col class="font-32 cor-33">{{ handleStrYear(foodOrderStat.title) }}</van-col>
        <van-col class="font-32 cor-cc">
          <van-button @click="nextWeek">下一周</van-button>
        </van-col>
      </van-row>

      <!--  站位盒子  -->
<!--      <div class="font-28 cor-B3 m-t-20">-->
<!--        点击"已订"可以查看预订详情-->
<!--      </div>-->


    </div>
    <div class="h-100"></div>

    <div class="p-20">
      <div v-for="(item, index) in foodOrderStat.dayCol" :key="index" class="font-30 m-t-10 bg-FF text-center">
        <van-row type="flex" align="center">
          <van-col :span="6">
            <div class="p-20" v-if="item" style="background-color: #FEE345;">
              <img :src="`${image_base_url}/rili.png`" class="w-32 h-32"/>
              <div class="m-t-100">{{ item.substring(0, 2) }}</div>
              <div class="m-t-100">{{ item.substring(3, 9) }}</div>
            </div>
          </van-col>
          <van-col :span="18" class="p-10">
            <div v-if="item">
              <van-row type="flex" align="center" style="border-bottom: 1px solid #ccc;" class="p-b-10 ">
                <van-col :span="14">
                  <div style="display: flex;align-items: center;">
                    <img :src="`${image_base_url}/canting.png`" class="w-32 h-32"/>
                    <div class="m-l-10" style="color: #666666;">餐厅</div>
                  </div>
                </van-col>
                <van-col :span="5">
                  <div style="display: flex;align-items: center;">
                    <img :src="`${image_base_url}/wucan.png`" class="w-32 h-32"/>
                    <div class="m-l-10" style="color: #666666;">午餐</div>
                  </div>
                </van-col>
                <van-col :span="5">
                  <div style="display: flex;align-items: center;">
                    <img :src="`${image_base_url}/wancan.png`" class="w-32 h-32"/>
                    <div class="m-l-10" style="color: #666666;">晚餐</div>
                  </div>
                </van-col>
              </van-row>
              <div v-for="(item1, index1) in foodOrderStat.datas" :key="index1" class="m-t-10">
                <van-row type="flex" align="center" class="text-left">
                  <van-col :span="14">
                    <div>{{ item1.name }}</div>
                  </van-col>
                  <van-col :span="5">
                    <div>
                      <div v-if="item1.list[index].details[0].status != 0" style="color: #B2B2B2" @click="yd(item1.list[index].details[0])">
                        已订
                      </div>
                      <div v-else style="color: #F4920D" @click="wd(item1.list[index].details[0], index)">
                        <van-button size="small" type="primary">订餐</van-button>
                      </div>
                    </div>
                  </van-col>
                  <van-col :span="5">
                    <div>
                      <div v-if="item1.list[index].details[1].status != 0" style="color: #B2B2B2" @click="yd(item1.list[index].details[1])">
                        已订
                      </div>
                      <div v-else style="color: #F4920D" @click="wd(item1.list[index].details[1], index)">
                        <van-button size="small" type="primary">订餐</van-button>
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>
          </van-col>
        </van-row>


      </div>

    </div>
  </div>
</template>
<script>
import {getFoodOrderStat} from "@/api/flow";
import mixin from '@/mixin/flow'
import moment from "moment";

export default {
  mixins: [mixin],
  data() {
    return {
      queryParams: {
        week: 0,
        nowMonth: 0,
        nextMonth: 0
      },
      foodOrderStat: {}
    }
  },
  created() {
    this.queryParams.nowMonth = moment().month() + 1;
    this.queryParams.nextMonth = moment().month() + 2;
    this.getData()
  },
  methods: {
    getData() {
      return new Promise(resolve => {
        this.$loading.show()
        getFoodOrderStat(this.queryParams).then(res => {
          this.$loading.hide()
          this.foodOrderStat = res.data
        })
      })
    },

    wd(data, index) {
      const obj = {
        ycrq: data.date,
        ycdd: [data.place],
        yclx: data.type
      }
      this.$emit('reserving', obj)


    },

    yd(data) {

      // uni.navigateTo({
      //   url: '/pages/reservation/reservationDetails?processInstanceId=' + data.foodOrder.instanceId + '&pageType=view',
      // })
    },
    lastWeek() {
      this.queryParams.week = this.queryParams.week - 1;
      this.getData()
    },
    nextWeek() {
      this.queryParams.week = this.queryParams.week + 1;
      this.getData()
    },
    /**
     *  处理年份
     */
    handleStrYear(str) {
      if (str) {
        var start = str.substring(5, 12);
        var end = str.substring(17, 23);
        return start + end;
      }
      return str;
    },
  }
}
</script>
